<template>
    <div class="contenedor">
        <b-row>
            <b-col xl="1">
                <b-form-select v-model="selected" :options="options"></b-form-select>
            </b-col>
            <b-col xl="1">
                <select :disabled="tdocdisabled" class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                        {{ tipodocumento.nombre }}
                    </option>
                </select> 
            </b-col>
            <b-col xl="1">
                    <!-- <div class="form-label-group"> -->
                        <b-form-input type="text" :disabled="tipoDocumento==0" class="form-control address" v-model="receptor.numero" placeholder="Documento" autofocus @change="getReceivers()"></b-form-input>
                        <!-- <label>Documento</label> -->
                    <!-- </div> -->
                    <template v-if="cargandoreceptor">
                    <b-list-group class="searcher-field">
                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                    </b-list-group>
                    </template>
                    <b-list-group v-if="listarec" class="searcher-field">
                    <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                    <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                        <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                        {{item.idReceptor + ' - ' + item.razonSocial}}
                        </b-list-group-item>
                    </template>
                    </b-list-group>
                    <b-list-group v-if="mostrardni" class="searcher-field">
                            <b-list-group-item v-if="norecdni">No hay Receptores con ese número</b-list-group-item>                                 
                        <template >
                            <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                        </template> 
                    </b-list-group>  
            </b-col>
            <b-col xl="2">
              
                <b-input-group>
                    <!-- <div class="form-label-group"> -->
                        <b-form-input 
                            type="text"
                            placeholder="Razón Social" 
                            class="form-control address"
                            @input="pitcherReceiver()" 
                            v-model="receptor.razonSocial"  
                            autofocus>
                        </b-form-input>
                        <!-- <label>Razon Social</label> -->
                    <!-- </div> -->
                    <b-input-group-append>
                        <b-button class="pt-0 pb-0" 
                            v-b-tooltip.hover="{ variant: 'info' }" 
                            title="Buscar en Negocios" 
                            variant="primary" 
                            @click="buscarNegocios()">
                            <i class="fa fa-male" aria-hidden="true"></i>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-modal size="lg" v-model="negocios">
                <template slot="modal-header">
                    <h5>Buscar en Negocios</h5>
                </template>
                <b-form-group  class="mb-0">
                    <b-input-group>
                    <b-form-input v-model="filter" placeholder="Ingresar Búsqueda" />
                    <b-input-group-append>
                        <b-btn variant="primary" :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                    </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <br>
                <b-table
                    head-variant="light"
                    hover
                    responsive
                    :busy="isBusy"
                    small
                    outlined
                    :items="customers"
                    :fields="customers_fields"
                    :filter="filter"
                    :per-page="limite"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @row-clicked="handleRowClick"
                    :row-class="() => ({ 'clickable-row': true })"
                    style="cursor: pointer;">
                </b-table>
                <template slot="modal-footer">
                   <b-button variant="dark" @click="cerrarNegocios">Cerrar</b-button>
                </template>
            </b-modal>
            <b-col xl="2">
                <!-- <div class="form-label-group"> -->
                    <b-form-input type="text" class="form-control address" v-model="receptor.direccion" placeholder="Dirección" autofocus></b-form-input>
                    <!-- <label>Dirección</label> -->
                <!-- </div> -->
            </b-col>
            <b-col cols="12" sm="3" md="3" lg="3" xl="3" >
                <b-input-group>
                    <b-form-input
                        placeholder="Buscar producto"
                        @change="searchProduct()"
                        @input="cadenabusqueda = cadenabusqueda.toUpperCase()"
                        v-model="cadenabusqueda">
                    </b-form-input>
                    <b-input-group-append>
                        <b-button 
                            lass="pt-0 pb-0" 
                            variant="success" 
                            @click="searchProduct()">
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button class="pt-0 pb-0" 
                            v-b-tooltip.hover="{ variant: 'info' }" 
                            title="Actualizar Productos" 
                            variant="primary" 
                            @click="listProduct()">
                            <i class="fas fa-redo"></i>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col xl="1">
                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="moneda">
                    <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                    {{ moneda.descripcion }}
                    </option>
                </select>
            </b-col>
            <b-col xl="1">
                    <b-input-group>
                    <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                            Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    </template>
                    <template v-else>
                    <select class="form-control input-placedark input-dark" v-model="indexSerie">
                        <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                    </select>
                    </template>
                </b-input-group>
            </b-col>
        </b-row><br>
        <b-row>
            <b-col xl="3">
                <div class="itemstotales">
                    <div class="vistaitems">
                        <div v-if="listaProductos.length == 0" class="carritovacio">
                            Su carrito de compras esta vacio
                        </div>
                        <b-list-group v-else>
                            <b-row> 
                                <b-col cols="6">
                                    <div style="text-align: center;">
                                        <h5>Artículos</h5>
                                    </div>
                                </b-col> 
                                <b-col cols="6">
                                    <h5><b-badge></b-badge></h5>
                                    <div style="text-align: center;">
                                        <h5># {{ listaProductos.length }}</h5>
                                    </div>
                                </b-col>
                            </b-row>                                           
                            <b-list-group-item v-for="(i, ind) in listaProductos" :key="ind" >
                                <b-row>
                                    <b-col style="font-size: 12px;" xl="11">
                                        <b>{{ i.descripcion.toUpperCase() }}</b><br> 
                                        <b-button class="p-0" variant="light" size="sm"  @click="AgregarCantidad(i, ind)">{{i.cantidad}}</b-button>
                                        UNIDAD X <b>{{ moneda.simbolo }} {{ i.precioVentaUnitario }}</b>
                                    </b-col>
                                    <b-col class="pl-0" xl="1">
                                        <i @click="borrarProducto(ind)" class="fa fa-trash danger text-danger cursor"></i> 
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                        </b-list-group>             
                    </div><hr>
                    <div>
                            <b-row>
                                <b-col cols="6">
                                    <div class="subtotales">
                                        Gravado:
                                    </div>
                                </b-col>
                                <b-col cols="6">
                                    <template v-if="listaProductos.length > 0">
                                        {{moneda.simbolo}}  {{ accumulateGravado() }}
                                    </template>
                                    <template v-else>
                                        {{moneda.simbolo}} 0.00
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6">
                                    <div class="subtotales">
                                        Impuestos:
                                    </div>
                                </b-col>
                                <b-col cols="6">
                                    <template v-if="listaProductos.length > 0">
                                        {{moneda.simbolo}} {{ accumulateImpuestos() }} 
                                    </template>
                                    <template v-else>
                                        {{moneda.simbolo}} 0.00
                                    </template> 
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6">
                                    <div class="subtotales">
                                        Otros Cargos:
                                    </div>
                                </b-col>
                                <b-col cols="6">
                                    <template>
                                        {{moneda.simbolo}} {{ accumulateOtrosCargos() }} 
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6">
                                    <div class="subtotales">
                                        Total:
                                    </div>
                                </b-col>
                                <b-col cols="6">
                                    <template v-if="listaProductos.length > 0">
                                        {{moneda.simbolo}} {{ accumulateTotal() }}
                                    </template>
                                    <template v-else>
                                        {{moneda.simbolo}} 0.00
                                    </template>  
                                </b-col>
                            </b-row>
                    </div>  
                    <b-col cols="12" sm="12" md="12" lg="7" xl="12" v-if="selected!='11'">
                    <div>
                        <div>
                        <b-row>
                            <!-- <b-col>
                                <b-button
                                v-b-modal.otroscargosmodal1
                                variant="secondary"
                                :disabled="this.listaProductos.length > 0 ? false:true"
                                >
                                <i class="fa fa-hand-holding-usd"></i> Otros Cargos
                                </b-button>
                            </b-col> -->
                            <!-- <b-modal  
                            id="otroscargosmodal1"
                            title="Agregar Otros Cargos"
                            size="lg"
                            centered
                            v-model="otroscargosmodal">  
                            <template>
                            <b-row>
                                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                <b-form-input disabled title="Cargos globales que no afectan la base imponible del IGV/IVAP" placeholder="Cargos globales que no afectan la base imponible del IGV/IVAP"></b-form-input>
                                </b-col>
                                <b-col cols="2" sm="2" md="1" lg="1" xl="1">
                                <p class="mt-2">{{ moneda.simbolo }}</p>
                                </b-col>
                                <b-col cols="8" sm="8" md="4" lg="4" xl="4">
                                <b-form-input
                                        type="number"
                                        v-model="montoOtroCargo"
                                        placeholder="Monto del cargo"
                                        @keyup.enter="addMontoCargo()"
                                ></b-form-input>
                                </b-col>
                                <b-col cols="2" sm="2" md="1" lg="1" xl="1">
                                <b-button variant="success" @click="addMontoCargo()">
                                    <i class="fa fa-plus"></i>
                                </b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                                <b-table
                                        striped
                                        hover
                                        small
                                        responsive
                                        outlined
                                        :fields="otroscargos_fields"
                                        :items="listaOtrosCargosAgregados"
                                >
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                    </div>
                                    <template slot="descripcion" slot-scope="row">
                                    <div
                                            v-if="row.item.codigoCargoDescuento==50"
                                    >Cargos globales que no afectan la base imponible del IGV/IVAP</div>
                                    </template>
                                    <template
                                            slot="montoCargo"
                                            slot-scope="row"
                                    >{{ moneda.simbolo }} {{ row.item.montoCargoDescuento }}</template>
                                    <template slot="acciones" slot-scope="row">
                                    <b-button
                                            size="sm"
                                            variant="danger"
                                            @click="deleteOtroCargo(row.index, row.item)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                    </template>
                                </b-table>
                                </b-col>
                            </b-row>
                            </template>                             
                            </b-modal> -->
                        </b-row>
                        <hr style="border: none;height: 3px;background-color: gray;width: 100%; margin: 20px 0;">
                        <b-row class="mb-2">
                            <b-col cols="12" sm="5" md="5" lg="5" xl="6">
                                <b-input-group>
                                <b-button v-if="formadepago.codigo =='00'"  v-b-tooltip.hover="'ver cuotas crédito'" style="border:none" variant="outline-primary" class="sinresultados mr-1" size="sm" @click="vercreditos()"><i class="fas fa-eye"></i></b-button>
                                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                    <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                        {{ fpago.nombre }}
                                    </option>
                                </select>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="1" xl="1">
                               <div class="mt-2">
                                   {{moneda.simbolo}}
                              </div>
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="5" xl="4">
                                <b-form-input @keyup.enter='validarImporteTotal()' v-model="pagatotal"></b-form-input>
                            </b-col>                        
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="5" md="5" lg="5" xl="6">
                                <div class="mt-2 ml-2">
                                    Vuelto:
                                </div>                             
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="1" xl="1">
                              <div class="mt-2">
                                {{moneda.simbolo}}
                              </div>
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="5" xl="4">
                                <b-form-input v-model="vueltoTotal" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <hr style="border: none;height: 3px;background-color: gray;width: 100%; margin: 20px 0;">
                        <b-row>
                            <b-col cols="12" sm="1" md="1" lg="1" xl="7">
                                <!-- <b-button style="width: 100%;" class="mt-2" variant="success" :disabled="validarVenta()" @click="realizarVenta()" ><i class="fa fa-money"></i>PAGAR</b-button> -->
                                <b-button variant="success" @click="validarImporteTotal()" ><i class="fa fa-money"></i>PAGAR</b-button>
                            </b-col>
                            <b-col cols="12" sm="1" md="1" lg="1" xl="5">
                                <b-button variant="primary" :disabled="this.listaProductos.length==[]" @click="abrirTecladoPago()" ><i class="fa fa-money"></i>TECLADO</b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago Efectivo" class="formasPagosImg" src="images/efectivo1.png" @click="pagosImg(5)"><b-badge v-if="colorPago5" style="color:green">Efectivo</b-badge><p v-else>Efectivo</p></b-col>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago con Yape" class="formasPagosImg" src="images/yape.png" @click="pagosImg(1)"><b-badge v-if="colorPago1" style="color:green">Yape</b-badge><p v-else>Yape</p></b-col>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago con Plin" class="formasPagosImg" src="images/plin.png" @click="pagosImg(2)"><b-badge v-if="colorPago2" style="color:green">Plin</b-badge><p v-else>Plin</p></b-col>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago A Crédito" class="formasPagosImg" src="images/Acredito.png" @click="pagosImg(3)"><b-badge v-if="colorPago3" style="color:green">A crédito</b-badge><p v-else>Crédito</p></b-col>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="T.Débito" class="formasPagosImg" src="images/tDebito.png" @click="pagosImg(4)"><b-badge v-if="colorPago4" style="color:green">T.Débito</b-badge><p v-else>T.débito</p></b-col>
                            <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="T.Crédito" class="formasPagosImg" src="images/tCredito.png" @click="pagosImg(6)"><b-badge v-if="colorPago6" style="color:green">T.Crédito</b-badge><p v-else>T.crédito</p></b-col>
                        </b-row>
                        </div>
                    </div>
                    </b-col>
                    <totales :items="listaProductos" :pdv="pdv" :monedabuffer="moneda" @loadtotal="insertTotal"></totales>    
                    <div class="ajusteOP" v-if="selected == 11">
                    <b-col cols="12" sm="12" md="12" lg="7" xl="12">
                            <strong>Detalles:</strong>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="11">
                                    <b-form-input type="text" class="nombre" placeholder="Atencion a:" v-model="atencion" autofocus></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="11">
                                    <b-form-input type="text" class="nombre mt-2" placeholder="Plazo de entrega:" v-model="plazoentrega" ></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="11">
                                    <b-form-input type="text" class="nombre mt-2" placeholder="Forma de pago:" v-model="tipoPago" ></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="0" sm="0"	md="6"	lg="6"	xl="11">
                                    <b-form-textarea
                                    class="mt-2"  
                                    v-model="observaciones"
                                    rows="3"
                                    max-rows="6"
                                    placeholder="Observacion General ">
                                    </b-form-textarea>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                                    <b-form-input type="text" class="nombre" placeholder="Garantia:" v-model="garantia"></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="5">
                                    <b-form-input type="text" class="nombre" placeholder="Teléfono:" v-model="telefono"></b-form-input>
                                </b-col> 
                            </b-row>
                            <b-row class="mt-2">
                                <b-col cols="12" sm="5" md="5" lg="4" xl="11">
                                    <b-select   v-model="tag3">
                                        <option value=""> Seleccione Etiqueta </option>
                                        <option v-for="tag in listaTag" v-if="tag.numeroTag == 3" :key="tag.id" :value="tag">{{ tag.tag }}</option>
                                    </b-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="12">
                                    <div>
                                        <b-button style="width: 100%;" :disabled="validarOP()" @click="sendOP()" variant="success" class="mt-2" >Guardar OP</b-button>
                                    </div>
                                </b-col>
                            </b-row>  
                    </b-col>
                    </div>  
           <b-modal v-model="modaltarjeta">
               <template slot="modal-header">
                <div class="text-center">
                Pago con Tarjeta <i class="far fa-credit-card"></i>
                </div>
                </template>
               <div>
                    <b-input-group>
                        <b-input-group-prepend is-text >
                            <i class="fas fa-hashtag"></i>
                            </b-input-group-prepend>
                        <b-form-input  placeholder="Código de Opereacion" v-model="codigoOperacion"></b-form-input>
                    </b-input-group>
                </div>
                <template slot="modal-footer">   
            <b-button size="sm"  class="btn btn-info" @click="procesarOperacion()"><i class="far fa-credit-card"></i> Procesar</b-button>
            <b-button size="sm" class="btn btn-dark" @click="cancelarOperacion()">Cancelar</b-button>
            </template>   
           </b-modal>
        </div>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="9">
                <div v-if="favoritos.length>0" class="card scrollFavoritos">
                    <b-row>
                        <b-col cols="12" sm="3" md="3" lg="3" xl="12" >
                        <div>
                            <!-- <template v-if="cargandoProd">
                                <div class="text-center mt-5">
                                    <h3>Cargando Productos <i class="fa fa-spin fa-spinner"></i></h3> 
                                </div>
                            </template> -->
                            <template>
                                <div v-for="(i, ind) in favoritos" :key="ind" class="listaproducto">
                                    <div id="block-1-favoritos">
                                        <div id="inner-block">
                                            <div v-if="i && i.uriImagen">
                                                <b-img left :image="i" :src="i.uriImagen" @click="productoSeleccionado(i)" height="130px" alt="Left image" style="width:84PX"></b-img>                                
                                            </div>
                                            <div v-else>
                                                <b-img :image="i" src="images/productoSinImagen.jpg" @click="productoSeleccionado(i)" height="82px" alt="Left image" style="width:82px"></b-img>                                
                                            </div>                                      
                                        </div>
                                        <div id="block-2-favoritos">S/.{{ i.precioUnitario }}</div>
                                        <div id="block-3-favoritos" style="text-transform: uppercase;">{{ i.descripcion }}</div>
                                        <div id="block-4">
                                            <b-button
                                                variant="outline-light"
                                                style="background-color: #4dbd74;border:none"
                                                size="sm" 
                                                :class="{ 'star-yellow': esFavorito(i) }" 
                                                @click="toggleFavorito(i)">
                                                <i class="fa fa-star" aria-hidden="true"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        </b-col>
                    </b-row>
                </div>
                <b-tabs v-model="tabIndex">
                    <b-tab active title="GENERAL">
                        <template v-if="tabIndex == 0">  
                            <div class="cardProductos scrollProductos" >               
                            <b-row>
                                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                                    <template v-if="cargandoProd">
                                        <div class="text-center mt-5">
                                        <h3>Cargando Productos <i class="fa fa-spin fa-spinner"></i></h3> 
                                       </div>
                                    </template>
                                    <template v-else>
                                    <div v-for="(i, ind) in productosimg" :key="ind" class="listaproducto">
                                        <div id="block-1">
                                            <div id="inner-block">
                                                <div v-if="i && i.uriImagen">
                                                    <b-img left :image="i" :src="i.uriImagen" @click="productoSeleccionado(i)" height="147px" alt="Left image" style="width:155px"></b-img>                                
                                                </div>
                                                <div v-else>
                                                    <b-img :image="i" src="images/productoSinImagen.jpg" @click="productoSeleccionado(i)" height="144px" alt="Left image" style="width:155px"></b-img>                                
                                                </div>                                      
                                            </div>
                                            <div id="block-2">S/.{{ i.precioUnitario }}</div>
                                            <div id="block-3" style="text-transform: uppercase;">{{ i.descripcion }}</div>
                                            <div id="block-4">
                                                <template v-if="i.esFavorito">

                                                </template>
                                                <template v-else>
                                                    <b-button
                                                        variant="ligth"
                                                        size="sm" 
                                                        :class="{ 'star-yellow': esFavorito(i) }"
                                                        @click="toggleFavorito(i)">
                                                        <i class="fa fa-star text-black" aria-hidden="true"></i>
                                                    </b-button>
                                                </template>
                                            </div>                 
                                        </div>
                                    </div>
                                    </template>                                                                                                                         
                                </b-col>
                            </b-row>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab
                    v-for="(categoria, index) in listaCategoria" 
                    :key="index"
                    @click="searchProductCategoria(categoria, index)">
                    <template slot="title">
                    <h6 class="colorTituloCategoria">{{ categoria.descripcion }}</h6>
                    </template>
                        <template v-if="tabIndex === index +1">
                            <div class="cardProductos scrollProductos" >               
                                <b-row>
                                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                                    <template v-if="cargandoProductoCateg">
                                        <div class="text-center mt-5">
                                        <h3>Cargando Productos <i class="fa fa-spin fa-spinner"></i></h3> 
                                       </div>
                                    </template>
                                    <template v-else-if="productosCategoria.length == 0">
                                        <div class="text-center mt-5">
                                            <h3><p>Sin productos para esta categoría</p></h3>
                                       </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="(i, ind) in productosCategoria" :key="ind" class="listaproducto">
                                            <div id="block-1">
                                                <div id="inner-block">
                                                    <div v-if="i && i.uriImagen">
                                                        <b-img left :image="i" :src="i.uriImagen" @click="productoSeleccionado(i)" height="147px" alt="Left image" style="width:155px"></b-img>                                
                                                    </div>
                                                    <div v-else>
                                                        <b-img :image="i" src="images/productoSinImagen.jpg" @click="productoSeleccionado(i)" height="144px" alt="Left image" style="width:155px"></b-img>                                
                                                    </div>                                      
                                                </div>
                                                <div id="block-2">S/.{{ i.precioUnitario }}</div>
                                                <div id="block-3" style="text-transform: uppercase;">{{ i.descripcion }}</div>               
                                            </div>
                                        </div>
                                    </template>                                                                                                                         
                                </b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                </b-tabs>
            </b-col>
            <b-col>
            </b-col>
        </b-row>
        <b-modal size="xs" v-model="modalimpresion">
            <template slot="modal-header">
                <div class="text-center">
                Telemovil
                </div>
            </template>
            <template>
            <plantilla :impresion="dataImpresion" :printweb="printweb"></plantilla>
            </template>
            <template slot="modal-footer">   
            <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
            <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
            </template>
        </b-modal>
       <b-modal v-model="errorPuntoventa" centered size="lg">
            <div>       
                <b-row no-gutters>
                <b-col md="5" class="ml-4">
                    <b-img src="images/error3.png"  height="260%" style="width:90%" ></b-img>
                </b-col>
                <b-col md="6">
                    <b-card-body title="Ups! error">
                        <b-card-text>
                            {{error1}} <br>
                            <hr>
                            {{error2}} <br>
                            <hr>
                            {{error3}}
                        </b-card-text>
                    </b-card-body>
                </b-col>
                </b-row>
            </div>
            <template slot="modal-footer">
                <b-button variant="danger" @click="cerrarmodal()" >Cerrar</b-button>
            </template>
        </b-modal>
        <b-modal v-model="mostrarCantidadItem">
            <template slot="modal-header">             
                <div>
                    <b-row>
                        <b-col> {{nombreProducto}}</b-col>
                    </b-row>
                </div>               
            </template>
            <b-row class="mb-2" v-if="mostrarCantidadItem">
                <b-col cols="12" sm="5" md="5" lg="4" xl="4">
                    Ingrese Cantidad :
                </b-col>
                <b-col cols="12" sm="5" md="5" lg="4" xl="5">
                    <b-form-input v-model="cantidadItem" autofocus></b-form-input>
                </b-col>
            </b-row>
            <div class="box2pago2 mb-4">
                <div class="boxboton2">
                    <b-button variant="light" @click="calculadora2(1)" class="bt-num2">1</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(2)" class="bt-num2">2</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(3)" class="bt-num2">3</b-button>
                </div><br>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(4)" class="bt-num2">4</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(5)" class="bt-num2">5</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(6)" class="bt-num2">6</b-button>
                </div><br>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(7)" class="bt-num2">7</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(8)" class="bt-num2">8</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(9)" class="bt-num2">9</b-button>
                </div><br>
                <div class="boxboton2">
                    <b-button variant="light"  @click="calculadora2(0)" class="bt-num2" >0</b-button>
                </div>
                <div class="boxboton2">
                    <b-button variant="danger" @click="del2()" class="bt-num2"><i class="fa  fa-backspace"></i></b-button>
                </div>
            </div> 
            <template slot="modal-footer">   
                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                    <b-button  variant="primary"  @click="GuardarCantidadItem()">Agregar</b-button>
                </b-col>
            </template> 
        </b-modal>
        <b-modal v-model="tecladoPago">
            <template slot="modal-header">             
                <div class="container-fluid cew-9">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <template v-if="listaProductos.length > 0">
                                Pagar: <b>{{moneda.simbolo}} {{ accumulateTotal() }}</b>
                            </template>
                            <template v-else>
                                <b>{{moneda.simbolo}} 0.00</b>
                            </template>  
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <template v-if="listaProductos.length > 0">
                                Pago: <b>{{moneda.simbolo}} {{ pagatotal }}</b>
                            </template>
                            <template v-else>
                                <b>{{moneda.simbolo}} 0.00</b>
                            </template>  
                        </div>
                        <div class="col-12 col-sm-12 col-md-4">
                            <template v-if="listaProductos.length > 0">
                                <b>Vuelto: {{moneda.simbolo}} {{ vueltoTotal }}</b>
                            </template>
                            <template v-else>
                                <b>{{moneda.simbolo}} 0.00</b>
                            </template>  
                        </div>
                    </div>
                </div>            
            </template>
            <b-col cols="12" sm="12" md="12" lg="7" xl="12">
            <div class="calculadorastyle">
                <div> 
                    <div class="boxfil2">
                        <div class="boxpago">
                            <b-button variant="light" class="bt-pago" :disabled="pagar" @click="validarImporteTotal()">
                                <b-row>
                                    <b-col>
                                        <i class="fa fa-4x fa-chevron-circle-right text-success"></i>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        Procesar Compra                 
                                    </b-col>
                                </b-row>
                            </b-button>
                        </div>
                        <div class="box2pago">
                            <div class="boxboton">
                                <b-button variant="light" @click="calculadora(1)" class="bt-num">1</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(2)" class="bt-num">2</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(3)" class="bt-num">3</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="danger" @click="del()" class="bt-num"><i class="fa  fa-backspace"></i></b-button>
                            </div><br>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(4)" class="bt-num">4</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(5)" class="bt-num">5</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(6)" class="bt-num">6</b-button>
                            </div><br>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(7)" class="bt-num">7</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(8)" class="bt-num">8</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(9)" class="bt-num">9</b-button>
                            </div><br>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora(0)" class="bt-num" >0</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="light"  @click="calculadora('.')" class="bt-num">.</b-button>
                            </div>
                            <div class="boxboton">
                                <b-button variant="info"  @click="PagarTarjeta()" class="bt-num"><i class="far fa-credit-card"></i></b-button>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
            </b-col>
            <template slot="modal-footer">   
                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                    <b-button  variant="primary"  @click="cerrarTecladoPago()">Cerrar</b-button>
                </b-col>
            </template>
        </b-modal>
        <!-- a CUOTAS CREDITO -->
        <b-modal size="lg" v-model="modalCredito">
      <b-row class="mb-2">
        <b-col cols="4">
          <datepicker class="input-placedark input-dark"
            v-model="fechaPagoCuota"
            :language="es"
            :format="customFormatter"
            :bootstrap-styling="true"
            placeholder="Fecha de Vencimiento"
          ></datepicker>
        </b-col>
        <b-col cols="4">
          <b-input class="text-center"
            type="number"
            v-model="montoPagoCuota"
            @keyup.enter='addcuota()'
            placeholder="Monto cuota"
          ></b-input>
        </b-col>
        <b-col>
          <b-button class="mt-1" variant="primary" size="sm" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
        </b-col>
      </b-row>
      <template slot="modal-header">
        <h5>Cuotas Crédito</h5>
      </template>
     <b-table
     :outlined="outlined"
      small   
      :items="cuotasCredito" 
      :fields="cuotas_credito">
      <template slot="acciones" slot-scope="row">
          <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
      </template>
     </b-table>
     <template>
       <div slot="modal-footer" class="w-100">
         <b-row>
         <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
           <div style="color:">
             <h5>Total Credito : {{totalcredito}}</h5>
           </div>
         </b-col>
         <b-col cols="12" sm="12" md="2" lg="2" xl="2">
           <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
         </b-col>
       </b-row>
       </div> 
      </template>
    </b-modal>
    </div> 
</template>

<script>
import axios from 'axios'
import Producto from '@/components/comunes/Producto'
import CalculadorPagos from '@/components/comunes/CalculadorPagos'
import { DocumentosIdentidad } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { FormaPagoPDV } from '@/shared/utils'
import Plantilla from '@/components/comunes/PlantillaImpresion'
import { es } from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker";
import Totales from '@/components/comunes/Totales'
    export default {
        name: 'PuntoVenta',
        components: {
            Producto,
            CalculadorPagos,
            Plantilla,
            Datepicker,
            Totales
        },
        data: () => {
            return {
                tabIndex: 0,
                sumatotal: "",
                sumaimpuestos: 0.00,
                listaProductos: [],
                pagar: true,
                vueltoTotal:'',
                pagatotal:"",
                productosimg:[],
                productosCategoria:[],
                pactual: 1,
                limite: 100,
                orden: "desc",
                cantidadItems:[],   
                cantItem:'',
                simbolo:'S/.',
                
                parambus:'name',
                cargandoproducto: false,
                cadenabusqueda: "",

                selected:0,
                options: [
                    { value: 1, text: '(F) Factura' },
                    { value: 2, text: '(B) Boleta' },
                    { value: 11, text: '(OP) OrdenPago' },
                    { value: 12, text: '(NV) Nota de Venta' },            
                ],
                tdocdisabled: false,
                tipoDocumento:0,
                documentosIdentidad: DocumentosIdentidad,
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''                
                },
                cargandoreceptor: false,
                listarec: true,
                listaReceptores: [],
                rucValid: true,
                moneda: '',
                moneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                tipoMoneda: TipoMoneda,
                seriesCargadas: false,
                indexSerie: 0,
                listaSeries: [],

                montoTotalImpuestos: 0.00,
                femision: '',
                fvencimiento:'',
                listaCorreos: [],
                cargosDescuentosGlobales:[],
                ticket: {
                    email: [],
                    tipoOperacion: '',
                    serie: '',
                    montoTotalImpuestos: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaExonerada: 0.00,
                    sumatoriaIgv: 0.00,
                    importeTotal: 0.00,
                    adicional: {
                        dirAlternativa: '',
                        tipo_igv:''
                    },
                    items: [],
                    receptor: {
                        tipo: '',
                        nro: '',
                        razonSocial: '',
                        direccionFiscal: ''
                    },
                    cargosDescuentosGlobales:[]
                },
                cantidadItem:1,
                mostrarCantidadItem:false,
                tecladoPago:false,
                setIndex: -1,
                 dataImpresion: {},
                 pago: 0.00,
                 vuelto: 0.00,
                 modalimpresion: false,
                 printweb: false,
                 guardandoValores:[],
                 codigoOperacion:'',
                 modaltarjeta: false,
                 nombreProducto:'',
                 mostrardni:false,
                norecdni:false,
                listadni:[],
                errorPuntoventa:false,
                error1:'',
                error2:'',
                error3:'',
                formaPago: FormaPagoPDV,
                formadepago: {
                    codigo: '008',
                    nombre: 'Efectivo ventas menores'
                },
                modalCredito:false,
                fechaPagoCuota:'',
                montoPagoCuota:'',
                totalcredito:0.0,
                cuotasCredito:[],
                cuotas_credito:[
                    {key:'identificadorCuota',label:'Cuotas'},
                    {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
                    {key:'montoPagoCuota', label:'Monto',},      
                    {key:'acciones', label:'Agregar'}
                ],
                validarcredito:true,
                outlined:true,
                es: es,
                notaVenta: {
                    receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                    },
                    adicional: {
                        tipo_igv:''
                    },
                    moneda: '',
                    plazoentrega: '',
                    formapago: '',
                    garantia: '',
                    telefono: '',
                    atencion: '',
                    observaciones: ''
                },
                ordenpago: {
                    receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                    },
                    adicional: {
                        tipo_igv:''
                    },
                    items:[],
                    moneda: '',
                    plazoentrega: '',
                    formapago: '',
                    garantia: '',
                    telefono: '',
                    atencion: '',
                    observaciones: '',
                    tag3:'',
                sistema:'facturaonline'
                },
                sistema:'facturaonline',
                idMovil: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                pdv:'',
                totales: {},
                otroscargosmodal:false,
                montoOtroCargo:'',
                listaOtrosCargosAgregados: [],
                otroscargos_fields: [
                { key: "descripcion", label: "Descripcion", sortable: true },
                { key: "montoCargo", label: "Monto", sortable: true },
                // {key: 'montoBaseCargo', label: 'Base', sortable: true},
                { key: "acciones", label: "Acciones" }
                ],
                sumatoriaOtrosCargos: 0,
                unoDieciocho:1.18,
                ceroDieciocho:0.18,
                dieciocho:18,
                // unoUno:1.1,
                // ceroUno:0.1,
                // diez:10,
                unoUno:1.105,
                ceroUno:0.105,
                diez:10.5,
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: '',
                tag3:'',
                listaTag:[],
                tipoPago: '',
                listaCategoria:[],
                colorPago1:false,
                colorPago2:false,
                colorPago3:false,
                colorPago4:false,
                colorPago5:false,
                colorPago6:false,
                colorPago7:false,
                colorPago8:false,
                cargandoProd:true,
                cargandoProductoCateg:true,
                isYellow: false, // Estado inicial
                favoritos: JSON.parse(localStorage.getItem('favoritos')) || [], // Cargar favoritos desde localStorage
                ocultarBotonFavorito:false,
                negocios:false,
                customers: [],
                customers_fields: [
                    { key: "documento", label: "Documento", sortable: true},
                    { key: "razonSocial", label: "Razón Social", sortable: true},
                    { key: "domFiscal", label: "Dirección por Defecto", sortable: true},
                ],
                currentPage: 1,
                isBusy: false,
                sortBy: null,
                sortDesc: false,
                sortDirection: "asc",
                filter: null,
                selectedData:{},
            }
        },
        mounted(){
            this.listProduct(),
            this.initDocument(),
            this.getSeries(),
            this.listTag();
            this.getCategoria();
            this.listTerceros();
            const favoritosGuardados = localStorage.getItem('favoritos');
                    if (favoritosGuardados) {
                this.favoritos = JSON.parse(favoritosGuardados);
            }
        },
        watch:{
            pagatotal(){
                if(this.pagatotal == parseFloat(this.sumatotal) && this.listaProductos.length>0){
                    this.vueltoTotal = 0
                    this.pagar = false         
                }else if(this.pagatotal > parseFloat(this.sumatotal) && this.listaProductos.length>0){
                   this.vueltoTotal = (this.pagatotal - parseFloat(this.sumatotal)).toFixed(2)
                   this.pagar = false
                }else if(this.pagatotal < parseFloat(this.sumatotal)){
                    this.vueltoTotal = 0
                    this.pagar = true
                }
            },
            selected: function () {
                this.getSeries()
                this.initReceptor()
                if(this.selected==1){
                    this.tipoDocumento = '6'
                    this.tdocdisabled = true
                }else if(this.selected==2){
                    this.tipoDocumento = '0'
                    this.tdocdisabled = false
                }else if(this.selected == 12){
                    this.tipoDocumento = '0'
                    this.tdocdisabled = false
                }
            },
            'receptor.numero': function () {
                if(this.receptor.numero==''){
                    this.initReceptor()
                }
            },
            'receptor.razonSocial': function () {
                if(this.receptor.razonSocial==''){
                    this.initReceptor()
                }
            },
            modalimpresion: function () {
                if(this.modalimpresion == false){
                    this.printweb = false
                }
            },
            formadepago(){
                if(this.formadepago.codigo == '00'){
                this.modalCredito = true;
            }   
            },
            montoPagoCuota(){
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                    this.validarcredito = false
                }else{
                    this.validarcredito = true
                }
            },
            fechaPagoCuota(){
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                    this.validarcredito = false
                }else{
                    this.validarcredito = true
                }
            },
        },
        methods: {
            customFormatter: function(date) {
                return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
            },
            listProduct: function() {
                this.cargandoProd = true;
                axios
            .post(process.env.VUE_APP_API_URL + "productos/listar", {
                token: this.$store.getters.userToken,
                page:  this.pactual,
                limit: this.limite,
                order: this.orden
            })
            .then(
                response => {
                this.productosimg = response.data.producto.data,
                this.cargandoProd = false,
                this.marcarFavoritos()
                })
            .catch(function(error) {
                this.$snotify.error(error.response.data.response.message, "Error");
                });
            },
            searchProduct: function() {
                this.cargandoproducto = true;
                axios
            .post(process.env.VUE_APP_API_URL + "productos/buscar", {
                token: this.$store.getters.userToken,
                filtro: this.parambus,
                p: this.cadenabusqueda
                // 'name, code, codesunat, codegs1'
                 // Parametro ej: Shoes -> sho
                })
            .then(
                response => (
                (this.productosimg = response.data.response),
                (this.cargandoproducto = false),
                (this.cadenabusqueda = "")
                ))
            .catch(
                error => (
                (this.cargandoproducto = false),
                this.$snotify.error(error.response.data.response.message, "Error")
                ));
            },
            searchProductCategoria: function(categoria, index) {
                this.cargandoProductoCateg = true;
                this.tabIndex = index;
                axios
            .post(process.env.VUE_APP_API_URL + "productos/buscar", {
                token: this.$store.getters.userToken,
                filtro: 'category',
                p: categoria.descripcion
                })
            .then(
                response => {
                    this.productosCategoria = response.data.response,
                    this.cargandoProductoCateg = false
                    
                })
            .catch(error => {
                    if(error){
                        this.productosCategoria = [],
                        this.cargandoProductoCateg = false
                    }
             });
            },
            getReceiversByRSocial: function () {
                if(this.receptor.razonSocial.length>=3 && this.tipoDocumento !=''){
                    this.cargandoreceptor = true
                    this.listarec = true
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.razonSocial,
                })
                .then(response => (
                    this.listaReceptores = response.data.response,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                })
                }else{
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }
            },
            getReceivers: function () {
                this.cargandoreceptor = true
                this.selected==1 ? this.receptor.tipo = '6': this.receptor.tipo = '0'
                if(this.receptor.numero.length >= 3){
                this.stateReceptorRuc(this.receptor.numero)
                if((this.rucValid && this.selected==1) || (this.selected==2)){
                this.listarec = true
                // lista/razonSocial
                    axios
                    .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: this.tipoDocumento
                    })
                    .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                    ))
                    .catch(error => (
                    this.listaReceptores = [],
                    this.cargandoreceptor = false,
                    this.listarec = false
                    // this.norec = false
                    ))
                }  
                }else if(this.receptor.numero.length === 0){
                this.listaReceptores = [],
                this.cargandoreceptor = false
                
                }else{
                this.listaReceptores = []
                }    
            },
            searchDNI(){
                this.cargandoreceptor = true
                this.mostrardni = true
                this.norecdni = false
                axios
                .get(process.env.VUE_APP_API_URL +'v2/dni',{
                    params:{
                        token: this.$store.getters.userToken,
                        dni: this.receptor.numero
                    }
                })
                .then(response => (
                        this.listadni = response.data,
                        this.cargandoreceptor = false,
                        this.receivedni(this.listadni)
                ))
                .catch(error => (
                    this.cargandoreceptor = false
                ))    
                
            },
            receivedni: function (value){
                if(!value)
                {
                    this.mostrardni = false
                    this.norecdni = true
                }
                else
                {
                    this.mostrardni = true
                    this.norecdni = false
                }
            },
            getSeries: function () {
                this.seriesCargadas = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.selected, {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listaSeries = response.data.data,
                    this.rolSeries = response.data.rol,
                    this.seriesCargadas = false,
                    this.igvGlobal = response.data.igv
                ))
                .catch(error => {
                    this.seriesCargadas = false
                })
            },
            validarVenta(){
               if(this.selected == 1){
                    if(this.receptor.numero !='' && 
                        this.receptor.razonSocial !='' && 
                        this.receptor.direccion !='' &&
                        this.listaProductos.length > 0 &&
                        this.pagatotal >=this.sumatotal){
                            return false;
                    }else{
                        return true;
                    }
               }else if(this.selected == 2){
                        if(this.sumatotal < 700 && this.listaProductos.length > 0 && this.pagatotal >= this.sumatotal){
                            return false;
                        }else if(this.sumatotal >= 700 &&
                                    this.tipoDocumento != '0' &&
                                    this.receptor.numero !='' &&
                                    this.receptor.razonSocial !='' &&
                                    this.pagatotal >= this.sumatotal){
                            return false;
                        }else{
                            return true;
                        }
               }else if (this.selected == 11 || this.selected == 12){
                    if(this.tipoDocumento != '0' && this.receptor.numero !='' && this.receptor.razonSocial !=''){
                        return false
                    }else if(this.sumatotal < 700 && this.listaProductos.length > 0 && this.pagatotal >= this.sumatotal){
                        return false;
                    }else{
                       return true;
                    } 
               }
            },
            realizarVenta(){
                switch (this.selected){
                    case 1:
                        this.sendTicket();
                    break;
                    case 2:
                        this.sendTicket();
                    break;
                    case 11:
                        this.sendOP()
                    break;
                    case 12:
                        this.sendNotaVenta()
                    break;
                }
            },
             validarImporteTotal: function () {
                 if(this.pagatotal < parseFloat(this.sumatotal)){
                     this.$snotify.warning('El monto a pagar deber ser mayor o igual al total','Cuidado')
                 }else{
                    if(this.selected == 1){
                        this.sendTicket()
                    }else{
                        if(parseFloat(this.sumatotal) >= 700 && this.tipoDocumento == '0'){
                            this.$swal({
                            title: 'Atención!!!',
                            text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
                            icon: 'warning',
                            buttons: true,
                            dangerMode: true
                            }).then((willDelete) => {
                            
                            })
                        }else{
                            if(this.selected != 12 || this.selected != 11 ){   
                                if(this.tipoDocumento != '0' && this.receptor.numero !='' && this.receptor.razonSocial !=''){
                                    this.sendTicket()
                                }else if(parseFloat(this.sumatotal) < 700 && this.tipoDocumento == '0'){
                                    this.sendTicket()
                                }else{
                                    this.$snotify.warning('Debe completar los datos del Receptor','Cuidado')
                                }  
                            }else if(this.selected == 11){
                                if(this.tipoDocumento != '0' && this.receptor.numero !='' && this.receptor.razonSocial !=''){
                                    this.sendOP()
                                }else if(parseFloat(this.sumatotal) < 700 && this.tipoDocumento == '0'){
                                    this.sendOP()
                                }else{
                                    this.$snotify.warning('Debe completar los datos del Receptor','Cuidado')
                                }  
                            }else if(this.selected == 12){
                                if(this.tipoDocumento != '0' && this.receptor.numero !='' && this.receptor.razonSocial !=''){
                                    this.sendNotaVenta()
                                }else if(parseFloat(this.sumatotal) < 700 && this.tipoDocumento == '0'){
                                    this.sendNotaVenta()
                                }else{
                                    this.$snotify.warning('Debe completar los datos del Receptor','Cuidado')
                                }  
                            }                     
                        }
                    }
                }

            },
            abrirTecladoPago(){
                this.tecladoPago = true;
            },
            cerrarTecladoPago(){
                this.tecladoPago = false;
            },
            nuevaImpresion(){
                this.modalimpresion = false
            },
            sendTicket: function () {
                this.emitiendo = true
                let ruta = ''
                this.ticket.token = this.$store.getters.userToken
                if(this.selected==1){
                    this.ticket.receptor.nro = this.receptor.numero.toString()
                    this.ticket.receptor.tipo = '6'
                    this.ticket.receptor.razonSocial = this.receptor.razonSocial
                    this.ticket.receptor.direccionFiscal = this.receptor.direccion
                    this.ticket.adicional.dirAlternativa = this.receptor.direccion
                }else{
                    if(this.tipoDocumento==0){
                        this.ticket.receptor.nro = '-'
                        this.ticket.receptor.tipo = '0'
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }else{
                        this.ticket.receptor.nro = this.receptor.numero
                        this.ticket.receptor.tipo = this.receptor.tipo
                        this.ticket.receptor.razonSocial = this.receptor.razonSocial
                        this.ticket.receptor.direccionFiscal = this.receptor.direccion
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }
                } 
                // if(this.typeticket == 1){
                if(this.indexSerie == 0){
                    this.ticket.serie = this.listaSeries[0]
                }else{
                    this.ticket.serie = this.listaSeries[this.indexSerie]
                }
                this.ticket.montoTotalImpuestos = this.montoTotalImpuestos
                this.ticket.totalVentaGravada = parseFloat(this.totalVentaGravada)
                this.ticket.sumatoriaIgv = this.montoTotalImpuestos
                this.ticket.importeTotal = parseFloat(this.sumatotal)
                this.ticket.tipoOperacion = '0101'
                if (this.sumatoriaOtrosCargos > 0) {
                    this.ticket.cargosDescuentosGlobales = this.listaOtrosCargosAgregados;
                    this.ticket.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos;
                }
                if(this.femision != ''){
                    this.ticket.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
                if(this.fvencimiento != ''){
                    this.ticket.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
                }
                if(this.formadepago.codigo != '000'){
                    if(this.formadepago.codigo === '00'){
                        this.ticket.adicional.credito = this.cuotasCredito
                        this.ticket.adicional.montoPendientePagoCredito = this.totalcredito
                        this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                    }else{
                        this.ticket.adicional.formaPago = this.formadepago.codigo
                         this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                    }
                }            
                this.ticket.adicional.dirAlternativa = this.receptor.direccion
                this.ticket.items = this.listaProductos,
                this.ticket.adicional.tipo_igv = this.igvGlobal
                this.ticket.email = this.listaCorreos,
                this.ticket.tipoMoneda = this.moneda.codigo
                this.selected==1 ? ruta = 'facturas/emitir': ruta = 'boletas/emitir'
                axios
                .post(process.env.VUE_APP_API_URL + ruta, this.ticket)
                .then(response => (
                    this.emitiendo = false,
                    this.$snotify.success(response.data.msg, 'Exito'),
                    this.dataImpresion = response.data.response,
                    this.dataImpresion.pagoCon = parseFloat(this.pagatotal),
                    this.dataImpresion.vuelto = parseFloat(this.vueltoTotal),
                    this.dataImpresion.razonSocial = this.receptor.razonSocial,
                    this.dataImpresion.direccion = this.receptor.direccion,
                    this.dataImpresion.tiporeceptor = this.receptor.tipo,
                     this.dataImpresion.OperacionCard = this.codigoOperacion,
                    // this.dataImpresion.adicionales = this.adicionales,
                    // this.dataImpresion.pagos = this.listaPagos,
                    this.modalimpresion = true,
                    // this.vistaimpresion = true,
                    // this.newimpresion = false,
                    // this.action.reset = true    
                    this.listaProductos=[],
                    this.guardandoValores =[],
                    this.pagatotal='',
                    this.receptor.numero = '',
                    this.receptor.direccion = '',
                    this.receptor.razonSocial = '',
                    this.receptor.tipo ='0',
                    this.selected = 2,
                    this.totalcredito = 0.0,
                    this.cuotasCredito = [],
                    this.formadepago = { 
                        codigo: "008", 
                        nombre: "Efectivo ventas menores"
                    },
                    this.montoPagoCuota = '',
                    this.fechaPagoCuota = '',
                    this.cargosDescuentosGlobales = [],
                    this.listaOtrosCargosAgregados = [],
                    this.ticket= {
                    email: [],
                    tipoOperacion: '',
                    serie: '',
                    montoTotalImpuestos: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaExonerada: 0.00,
                    sumatoriaIgv: 0.00,
                    importeTotal: 0.00,
                    adicional: {
                        dirAlternativa: ''
                    },
                    items: [],
                    receptor: {
                        tipo: '',
                        nro: '',
                        razonSocial: '',
                        direccionFiscal: ''
                    },
                    }
                ))
                .catch(error => (
                    this.emitiendo = false,
                   this.catchError(error.response.data)
                ))
            },
            catchError(value){
               this.errorPuntoventa = true;
               this.error1 = value.msg
               this.error2 = value.response.message
               this.error3 = value.response.description
            },
            cerrarmodal(){
                this.errorPuntoventa = false;
            },
            setReceiver: function (item) {
                this.receptor.numero = item.idReceptor,
                this.receptor.tipo = item.tipo,
                this.receptor.razonSocial = item.razonSocial,
                this.receptor.direccion = item.direccionReferencia,
                this.direcciones = item.direcciones,
                this.listaCorreos = item.email,
                this.listarec = false
                if(item.tipo =="1"){
                    this.tipoDocumento = 1
                }else if(item.tipo =="6"){
                    this.tipoDocumento = 6
                }
                this.listaReceptores = []
            },
            setReceiverdni(item){
                this.receptor.razonSocial = item.nombre
                this.mostrardni = false
                this.listarec = false
                this.listaReceptores = []
            },
            pitcherReceiver: function () {
                if(this.receptor.razonSocial.length >= 3 ){
                    setTimeout(() => this.getReceiversByRSocial(), 200);
                }else if(this.receptor.razonSocial.length <= 2){
                    this.initReceptor()
                }  
            }, 
            initReceptor: function () {
                this.receptor = {
                    numero:'',
                    tipo:'6',
                    direccion:'',
                    razonSocial:'',
                    direccionReferencia: ''
                },
                this.listaReceptores = [],
                this.cargandoreceptor = false
            },
            initDocument: function () {
                this.selected = 2
                this.dataImpresion = {}
                this.pdv = this.tipopdv
                this.pdv = 2
            },
            print: function () {
                this.printweb = true
            },
            stateReceptorRuc (value) {
                let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
                if(this.selected == 1){
                    if(value.length == 0){
                        this.rucValid = false
                    } else if (expreg.test(value)) {
                        this.$snotify.error('RUC Inválido','Error');
                        this.rucValid = false
                    } else {        
                        this.rucValid = true       
                    }   
                }
            },
            receivercount: function (value){
                if(!value)
                {
                // this.$snotify.warning('No se encontró al receptor', 'Atención')
                this.searchDNI();
                }
            },
            borrarProducto: function (index) {
                this.listaProductos.splice(index,1)
                this.guardandoValores.splice(index,1)
                if(this.listaProductos.length<=0){
                    this.pagar = true
                }
            },
            AgregarCantidad(value,index){
                this.mostrarCantidadItem = true
                this.setIndex = index
                this.nombreProducto = value.descripcion
                if(this.cantidadItem == 1 ){
                    this.cantidadItem = ""
                }
            },
            salirModal(){
                this.mostrarCantidadItem = false
                this.cantidadItem = 1
            }, 
            GuardarCantidadItem(){
                if(this.cantidadItem <=0){
                    this.$snotify.warning('Ingrese cantidad', 'Cuidado')
                    this.cantidadItem = 1
                }else{
                    this.guardandoValores
                    this.productoSeleccionado(this.guardandoValores[this.setIndex])
                }              
            },
            productoSeleccionado: function (value) { 
                let obtenerDatos = value;
                let cantItem;
                let item ={
                    unidadMedidaCantidad:'',
                    cantidad:'',
                    descripcion:'',
                    codigoProductoGs1:'',
                    codigoProductoSunat:'',
                    codigoProducto:'',
                    valorUnitario:'',
                    precioVentaUnitario:'',
                    tipoPrecioVentaUnitario:'',
                    montoTotalImpuestosItem:'',
                    baseAfectacionIgv:'',
                    montoAfectacionIgv:'',
                    porcentajeImpuesto:'',
                    tipoAfectacionIgv:'',
                    codigoTributo:'',
                    valorVenta:''
                }


                if(obtenerDatos.precioUnitario !=''){
                cantItem = obtenerDatos.precioUnitario * this.cantidadItem
                item.unidadMedidaCantidad = obtenerDatos.unidadMedida
                item.cantidad = parseFloat(this.cantidadItem)
                item.descripcion = obtenerDatos.descripcion
                item.codigoProductoGs1 = obtenerDatos.codigoProductoGs1
                item.codigoProductoSunat = obtenerDatos.codigoProductoSunat
                item.codigoProducto = obtenerDatos.codigo
                item.idProducto = parseFloat(obtenerDatos.idProducto)
                item.valorUnitario = parseFloat(parseFloat(obtenerDatos.precioUnitario/(this.$store.state.igv == 18 ? 1.18 : 1.105) ).toFixed(10))
                item.precioVentaUnitario = parseFloat(obtenerDatos.precioUnitario)
                item.tipoPrecioVentaUnitario = '01'
                item.montoTotalImpuestosItem = parseFloat(parseFloat((cantItem/(this.$store.state.igv == 18 ? 1.18 : 1.105) )*(this.$store.state.igv == 18 ? 0.18 : 0.105)))
                item.baseAfectacionIgv = parseFloat((obtenerDatos.precioUnitario * this.cantidadItem)/(this.$store.state.igv == 18 ? 1.18 : 1.105) )
                item.montoAfectacionIgv = parseFloat(item.montoTotalImpuestosItem)
                item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
                item.tipoAfectacionIgv = '10'
                item.codigoTributo = '1000'
                item.valorVenta = parseFloat((obtenerDatos.precioUnitario * this.cantidadItem)/(this.$store.state.igv == 18 ? 1.18 : 1.105) )
                }if(this.mostrarCantidadItem == true){
                cantItem = obtenerDatos.precioVentaUnitario * this.cantidadItem
                item.unidadMedidaCantidad = obtenerDatos.unidadMedidaCantidad
                item.cantidad = parseFloat(this.cantidadItem)
                item.descripcion = obtenerDatos.descripcion
                item.codigoProductoGs1 = obtenerDatos.codigoProductoGs1
                item.codigoProductoSunat = obtenerDatos.codigoProductoSunat
                item.codigoProducto = obtenerDatos.codigoProducto
                item.idProducto = parseFloat(obtenerDatos.idProducto)
                item.valorUnitario = parseFloat(parseFloat(obtenerDatos.precioVentaUnitario/(this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(10))
                item.precioVentaUnitario = parseFloat(obtenerDatos.precioVentaUnitario)
                item.tipoPrecioVentaUnitario = '01'
                item.montoTotalImpuestosItem = parseFloat(parseFloat((cantItem/(this.$store.state.igv == 18 ? 1.18 : 1.105))*(this.$store.state.igv == 18 ? 0.18 : 0.105)))
                item.baseAfectacionIgv = parseFloat((obtenerDatos.precioVentaUnitario * this.cantidadItem)/(this.$store.state.igv == 18 ? 1.18 : 1.105))
                item.montoAfectacionIgv = parseFloat(item.montoTotalImpuestosItem)
                item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
                item.tipoAfectacionIgv = '10'
                item.codigoTributo = '1000'
                item.valorVenta = parseFloat((obtenerDatos.precioVentaUnitario * this.cantidadItem)/(this.$store.state.igv == 18 ? 1.18 : 1.105))
            }
                if(this.setIndex != -1){
                Object.assign(this.listaProductos[this.setIndex], item)
                // this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
                this.setIndex = -1
                this.mostrarCantidadItem = false
                }else{
                    if(this.cantidadItem < 0){
                        this.$snotify.warning('Cantidad debe ser mayor a Cero', 'Atencion')
                    }else{
                        if(this.listaProductos.length>=0){
                        // Agregando el primer producto
                            this.listaProductos.push(item)
                            this.guardandoValores.push(item)   
                        }else if(this.listaProductos.length>0){
                            this.listaProductos.push(item)
                            this.guardandoValores.push(item)    
                        }
                    }
                    
                }
                item={}
                this.cantidadItem = 1
            },
            PagarTarjeta(){
                this.modaltarjeta = true;         
            },
            cancelarOperacion(){
            this.modaltarjeta = false; 
            },
            procesarOperacion(){
                if(this.codigoOperacion !=''){
                    this.pagatotal = this.accumulateTotal()
                    this.modaltarjeta = false; 
                }
            },
            accumulateImpuestos: function () {
                let impuestos = 0.00
                this.listaProductos.forEach(function(element) {
                    impuestos += parseFloat(element.precioVentaUnitario * element.cantidad)
                })  
                this.montoTotalImpuestos = impuestos-(impuestos/(this.$store.state.igv == 18 ? 1.18 : 1.105) )
                return (impuestos-(impuestos/(this.$store.state.igv == 18 ? 1.18 : 1.105))).toFixed(2)
            },
            accumulateOtrosCargos(){
                let val = 0.0;
                this.listaOtrosCargosAgregados.forEach(function(element) {
                    val += parseFloat(element.montoCargoDescuento);
                });
                this.sumatoriaOtrosCargos = val;
                return val.toFixed(2)
            },
            accumulateGravado(){
                let gravado = 0.00
                this.listaProductos.forEach(function(element){
                    gravado += parseFloat(element.precioVentaUnitario * element.cantidad)
                })
                this.totalVentaGravada = parseFloat(gravado/(this.$store.state.igv == 18 ? 1.18 : 1.105) ).toFixed(2)
                return (gravado/(this.$store.state.igv == 18 ? 1.18 : 1.105) ).toFixed(2)
            },
            accumulateTotal(){
                let val = 0.00;
                if(this.totalVentaGravada != 0 || this.montoTotalImpuestos != 0){
                    val = this.montoTotalImpuestos + parseFloat(this.totalVentaGravada) + this.sumatoriaOtrosCargos;
                    this.sumatotal = parseFloat(val.toFixed(2));
                    this.baseCargo = val - this.sumatoriaOtrosCargos;
                }          
                return val.toFixed(2)
            },
            // calculadora
            calculadora(number){
                if(this.operatorClicked === true) {
                    this.pagatotal = '';
                    this.operatorClicked = false;
                }
                this.pagatotal =this.pagatotal === 0 ? (this.pagatotal = number): '' + this.pagatotal + number;   
            },
            del(){
                    this.pagatotal = this.pagatotal.slice(0, -1)
            },
            calculadora2(number){
                if(this.operatorClicked === true) {
                    this.cantidadItem = '';
                    this.operatorClicked = false;
                }
                this.cantidadItem =this.cantidadItem === 0 ? (this.cantidadItem = number): '' + this.cantidadItem + number;   
            },
            del2(){
                // this.cantidadItem = this.cantidadItem.slice(0,-1)
                this.cantidadItem = 0;
            },
            clear(){
                this.pagatotal = 0;
            },
            addcuota(index,value){
                let sumatotales = 0
                sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                if(this.sumatotal >= this.montoPagoCuota ){
                    if(this.sumatotal >= sumatotales){
                    let total = 0.0
                    let cuota = {
                    identificadorCuota:'',
                    fechaPagoCuota:'',
                    montoPagoCuota:'',
                    } 
                    cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
                    cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
                    cuota.montoPagoCuota = this.montoPagoCuota;
                    this.cuotasCredito.push(cuota)

                    this.cuotasCredito.forEach(function(element){
                    total += parseFloat(element.montoPagoCuota);
                    }) 
                    this.totalcredito = total
                    this.fechaPagoCuota = '',
                    this.montoPagoCuota = ''
                    }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                    }  
                }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                }
                }
            },
            modalcredito(){
                this.modalCredito = false
            },
            deletecuota(index){ 
                let totalarray =''
                totalarray = this.cuotasCredito.length+1
                this.renameident(index)
                this.cuotasCredito.splice(index, 1);

                let total = 0.0
                this.cuotasCredito.forEach(function(element){
                total += parseFloat(element.montoPagoCuota);
                }) 
                this.totalcredito = total
            },
            renameident(index){ 
                for (let i=0;i < this.cuotasCredito.length; i++) {
                    if(i > index){
                    this.cuotasCredito[i].identificadorCuota = this.numerador(i)
                    }
                }
            },
            numerador(value){
            let cuotanom = value
            let cadenacuota = ''
            if(cuotanom >=1 && cuotanom <=9){
                    cadenacuota = 'Cuota00'+ String(cuotanom)
                }else if(cuotanom >=10 && cuotanom <=99){
                    cadenacuota = 'Cuota0'+ String(cuotanom)
                }else if(cuotanom >=100 && cuotanom <=999){
                    cadenacuota = 'Cuota'+ String(cuotanom)
                }
                return cadenacuota;
            },
            vercreditos(){
                this.modalCredito = true
            },
            sendNotaVenta(){
                let itemBlank = []
                if(this.loadNotaVenta()){
                    axios
                    .post(process.env.VUE_APP_API_URL + 'notaventa/insertar', {
                        token: this.$store.getters.userToken,
                        serie: this.listaSeries[this.indexSerie],
                        notaVenta: this.notaVenta
                    })
                    .then(response => (
                        this.$snotify.success(response.data.msg,'Exito'),
                        this.dataImpresion = response.data.response,
                        this.dataImpresion.notaVenta.receptor.razonSocial = this.receptor.razonSocial,
                        this.dataImpresion.notaVenta.receptor.direccionFiscal = this.receptor.direccion,
                        this.dataImpresion.notaVenta.receptor.tipo = this.receptor.tipo,
                        this.dataImpresion.adicionales = this.adicionales,
                        this.dataImpresion.vuelto = parseFloat(this.vueltoTotal),
                        this.dataImpresion.pagoCon = parseFloat(this.pagatotal),
                        this.modalimpresion = true,
                        this.vistaimpresion = true,
                        this.newimpresion = false,
                        this.action.reset = true
                    ))
                    .catch(error => {
                        this.$snotify.error(error.response.data.msg,'Error')
                    })
                }
            },
            loadNotaVenta: function () {
            this.notaVenta.receptor.tipo = this.tipoDocumento
            this.notaVenta.receptor.nro = this.receptor.numero
            this.notaVenta.receptor.razonSocial = this.receptor.razonSocial
            this.notaVenta.receptor.direccionFiscal = this.receptor.direccion
            this.notaVenta.moneda = this.moneda
            this.notaVenta.plazoentrega = this.plazoentrega
            this.notaVenta.formapago = this.tipoPago
            this.notaVenta.garantia = this.garantia
            this.notaVenta.telefono = this.telefono
            this.notaVenta.items = this.listaProductos
            this.notaVenta.totales = this.totales
            this.notaVenta.atencion = this.atencion
            this.notaVenta.observaciones = this.observaciones
            this.notaVenta.adicional.username = this.$store.getters.userData.username
            this.notaVenta.adicional.tipo_igv = this.igvGlobal
            this.notaVenta.adicional.codigoComprobante = '12'
            if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                    this.notaVenta.adicional.credito = this.cuotasCredito
                    this.notaVenta.adicional.montoPendientePagoCredito = this.totalcredito
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }else{
                    this.notaVenta.adicional.formaPago = this.formadepago.codigo
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }
            }
            return true
            },
            validarOP(){
                if(this.listaProductos.length > 0){
                    return false;
                }else{
                    return true;
                }
            },
            sendOP(){
                if(this.loadOrdenPago()){
                    axios
                    .post(process.env.VUE_APP_API_URL + "ordenpago/insertar",{
                        token: this.$store.getters.userToken,
                        serie: this.listaSeries[this.indexSerie],
                        ordenpago: this.ordenpago,
                        pagado: 0,
                        idMovil:this.idMovil
                    })
                    .then(response=>(
                        this.$snotify.success(response.data.msg,'Exito'),
                        this.initOP(),
                        this.initTicket()
                    ))
                    .catch(error => {
                        this.$snotify.error(error.response.data.msg,'Error')
                    })
                }
            },
            loadOrdenPago: function () {
                this.ordenpago.receptor.tipo = this.tipoDocumento
                this.ordenpago.receptor.nro = this.receptor.numero
                this.ordenpago.receptor.razonSocial = this.receptor.razonSocial
                this.ordenpago.receptor.direccionFiscal = this.receptor.direccion
                this.ordenpago.moneda = this.moneda
                this.ordenpago.atencion = this.atencion
                this.ordenpago.plazoentrega = this.plazoentrega
                this.ordenpago.formapago = this.tipoPago
                this.ordenpago.observaciones = this.observaciones
                this.ordenpago.garantia = this.garantia
                this.ordenpago.telefono = this.telefono
                this.ordenpago.items = this.listaProductos
                this.ordenpago.totales = this.totales
                this.ordenpago.adicional.username = this.$store.getters.userData.username
                this.ordenpago.adicional.tipo_igv = this.igvGlobal
                this.ordenpago.sistema = this.sistema
                this.ordenpago.tag3 = this.tag3.tag

                return true
            },
            initOP: function () {
                this.ordenpago.receptor.tipo = ''
                this.ordenpago.receptor.nro = ''
                this.ordenpago.receptor.razonSocial = ''
                this.ordenpago.receptor.direccionFiscal = ''
                this.ordenpago.moneda = ''
                this.ordenpago.plazoentrega = ''
                this.ordenpago.formapago = ''
                this.ordenpago.garantia = ''
                this.ordenpago.telefono = ''
                this.ordenpago.atencion = ''
                this.ordenpago.observaciones = ''
                this.ordenpago.adicional = {}
                this.tipoDocumento = '0'
                this.items = []
                this.tag3 = ''
                return true
            },
            listTag: function() {
            axios
              .post(process.env.VUE_APP_API_URL + "tag/listar", {
                token: this.$store.getters.userToken,
                limit: "40",
                order: "desc"
              })
              .then(
                response => (
                  (this.listaTag = response.data.data)
                )
              )
              .catch(error => (this.$snotify.error("Error")));
            },
            initTicket(){
                this.plazoentrega =''
                this.tipoPago = ''
                this.garantia = ''
                this.telefono = ''
                this.atencion = ''
                this.receptor.numero = ''
                this.receptor.direccion = ''
                this.receptor.razonSocial = ''
                this.receptor.tipo ='6',
                this.listaProductos = []
            },
            insertTotal: function (value) {
                if(value){
                this.totales = value
                }
            },
            addMontoCargo(){
                let otrocargo = {
                indicador: "",
                codigoCargoDescuento: "",
                factorCargoDescuento: "",
                montoCargoDescuento: "",
                baseCargoDescuento: "",
                };
                otrocargo.indicador = "cargo",
                otrocargo.codigoCargoDescuento =  "50",
                otrocargo.factorCargoDescuento =  parseFloat(((this.montoOtroCargo)/[(this.sumatotal-this.sumatoriaOtrosCargos)]).toFixed(5)),   
                otrocargo.baseCargoDescuento = parseFloat((this.baseCargo).toFixed(2)),
                otrocargo.montoCargoDescuento = parseFloat(((otrocargo.factorCargoDescuento)*otrocargo.baseCargoDescuento).toFixed(2))

                if (this.montoOtroCargo > 0) {
                this.listaOtrosCargosAgregados.push(otrocargo);
                this.montoOtroCargo = "";
                } else {
                this.$snotify.warning("El monto debe ser mayor a 0", "Cuidado");
                }
            },
            deleteOtroCargo: function(index, value) {
                this.$swal({
                title: "Eliminar Otro Cargo",
                text: "Seguro de eliminar el cargo con monto " + value.montoCargoDescuento,
                icon: "error",
                buttons: true,
                dangerMode: true
                }).then(willDelete => {
                if (willDelete) {
                    this.listaOtrosCargosAgregados.splice(index, 1);
                }
                });
            },
            getCategoria(){
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/categoria/listar',{
                    token: this.$store.getters.userToken,
                })
                .then(response =>(
                    this.listaCategoria = response.data
                ))
                .catch(error => {
                    console.log(error)
                })
            },
            pagosImg(valor){
                this.monederoPago = valor;
                valor == 1 ? this.colorPago1 = true : this.colorPago1 = false;
                valor == 2 ? this.colorPago2 = true : this.colorPago2 = false;
                valor == 3 ? this.colorPago3 = true : this.colorPago3 = false;
                valor == 4 ? this.colorPago4 = true : this.colorPago4 = false;
                valor == 5 ? this.colorPago5 = true : this.colorPago5 = false;
                valor == 6 ? this.colorPago6 = true : this.colorPago6 = false;
                if(valor == 1){
                this.formadepago.codigo = this.formaPago[9].codigo;
                this.formadepago.nombre = this.formaPago[9].nombre;
                }else if(valor == 2){
                this.formadepago.codigo = this.formaPago[9].codigo;
                this.formadepago.nombre = this.formaPago[9].nombre;
                }else if(valor == 3){
                this.formadepago.codigo = this.formaPago[8].codigo;
                this.formadepago.nombre = this.formaPago[8].nombre;
                this.modalCredito = true;
                }else if(valor == 4){
                this.formadepago.codigo = this.formaPago[2].codigo;
                this.formadepago.nombre = this.formaPago[2].nombre;
                }else if(valor == 5){
                this.formadepago.codigo = this.formaPago[0].codigo;
                this.formadepago.nombre = this.formaPago[0].nombre;
                }else if(valor == 6){
                this.formadepago.codigo = this.formaPago[3].codigo;
                this.formadepago.nombre = this.formaPago[3].nombre;
                }
            },
            marcarFavoritos() {
                this.productosimg.forEach((producto) => {
                    this.favoritos.forEach((favorito)=>{
                        if(producto.idProducto === favorito.idProducto){
                            producto.esFavorito = true;
                        }
                    })
                });
            },
            toggleFavorito(productoId) {
                // Alternar favorito
                const index = this.favoritos.indexOf(productoId);
                if (index === -1) {
                    // Si no está en favoritos, agregarlo
                    this.favoritos.push(productoId);
                } else {
                    // Si ya está en favoritos, eliminarlo
                    this.favoritos.splice(index, 1);
                }
                // Guardar favoritos en localStorage
                localStorage.setItem('favoritos', JSON.stringify(this.favoritos));
            },
            esFavorito(productoId) {
                // Verificar si un producto está en favoritos
                return this.favoritos.includes(productoId);

            },
            buscarNegocios(){
                this.negocios = true;
            },
            cerrarNegocios(){
                this.negocios = false;
            },
            listTerceros: function() {
            this.isBusy = true;
            axios
                .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
                })
                .then(response => (
                    (this.customers = response.data),
                    (this.isBusy = false)
                ))
                .catch(error => ((
                    this.nuevocliente = false), 
                    (this.isBusy = false)
                ));
            },
            handleRowClick(item) {
                // Captura los datos de la fila seleccionada
                this.selectedData = {
                    idReceptor: item.documento,
                    razonSocial: item.razonSocial,
                    direccionReferencia: item.domFiscal,
                    tipo: item.tipoDocumento
                };
                this.setReceiver(this.selectedData),
                this.negocios = false;
            },
        }
    }
</script>

<style lang="scss" scoped>

.scrollProductos::-webkit-scrollbar {
    -webkit-appearance: none;
}

.scrollProductos::-webkit-scrollbar:vertical {
    width:10px;
}

.scrollProductos::-webkit-scrollbar-button:increment,.contenedor::-webkit-scrollbar-button {
    display: none;
} 

.scrollProductos::-webkit-scrollbar:horizontal {
    height: 10px;
}

.scrollProductos::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.scrollProductos::-webkit-scrollbar-track {
    border-radius: 10px;  
}
.vistaitems{
    height: 50%;
    width: 100%;
    position: relative; 
    overflow-y: auto; /* Permite solo el scroll vertical */
    overflow-x: hidden; /* Oculta el scroll horizontal */
}
.calculadorastyle{
    margin-top: 3px;
}
.contenedor{
    width: 100%;
    height: 660%;
}
.itemstotales{
    width: 102%;
    height: 770px;
    border-right: 3px solid #ccc;
}
.jumbo{
    width: 200%;
    height: 10%;
}
.cardProductos{
    height: 600px;
    position: relative; 
    overflow-X: auto;
    border: none;
}
// calculadora
.boxfil2{
    border-radius: 5px;
    // background-color: #D0D3D4;
    width: 100%;
    height: 100%;
}
.boxpago{
    // float: left;
    display: inline-block;
    width: 30%;
    height: 150px;
}
.bt-pago{
    margin-top: 2px;
    margin-left: 2px;
    width:100%;
    height: 150px;
}
.box2pago{
    margin-right: 2px;
    display: inline-block;
    width: 69%;
    // height: 250px;
    float: right;
}
.boxboton{
    display: inline-block;
}
.bt-num{
    width: 71px;
    margin: 2px;
}
// cantidad
.box2pago2{
    margin-right: 2px;
    display: inline-block;
    height: 150px;
    // float: right;
}
.boxboton2{
    display: inline-block;
}
.bt-num2{
    width: 150px;
    height: 40px;
    margin: 2px;
}
// cantidad
.cero{
    width:104px
}
.cursor{
    cursor: pointer;
}
//imagen
#inner-block{
    float: right;
    position: absolute;
    width: 100px;
    height: 100px;
    margin: 2px;
    z-index: 100;
    }
    #block-1{
    border: 1px solid #ccc;
    margin: 15px;
    position: relative;
    width: 160px;
    height: 150px;
    border-radius: 5px;
    top: 1px;
    left: 1px;
    z-index: 1;
    cursor: pointer;
    }
    #block-2{
    background-color: #4dbd74;
    border-radius: 5px;
    padding-left: 5px;
    color: #fff;
    font-weight: 800;
    opacity: 0.9;
    position: absolute;
    width: 88px;
    height: 20px;
    top: 1px;
    // left: 79px;
    z-index: 1000;
    }
    #block-3{
    padding-left: 5px;
    position: absolute;
    width: 100%;
    height: 30px;
    top: 118px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 2000;
    background-color: #000;
    color: #fff;
    opacity: 0.7;
    font-size: 11px;
    }
    #block-4{
    border-radius: 5px;
    right: 0;
    position: absolute;
    z-index: 3000;
    }

    // ***SEPARACION FAVORITOS
    #block-1-favoritos{
    border: 1px solid #ccc;
    margin: 10px;
    position: relative;
    width: 90px;
    height: 135px;
    border-radius: 5px;
    top: 1px;
    left: 1px;
    z-index: 1;
    cursor: pointer;
    }
    #block-2-favoritos{
    background-color: #4dbd74;
    border-radius: 2.5px;
    padding-left: 2.5px;
    color: #fff;
    font-weight: 200;
    position: absolute;
    width: 100%;
    height: 28px;
    
    // left: 79px;
    z-index: 1000;
    font-size: 11px
    }
    #block-3-favoritos{
    padding-left: 2.5px;
    position: absolute;
    width: 100%;
    height: 45px;
    top: 90px;
    border-bottom-left-radius: 2.5px;
    border-bottom-right-radius: 2.5px;
    z-index: 2000;
    background-color: #000;
    color: #fff;
    opacity: 0.7;
    font-size: 10px;
    }

    //buscar documento
    .searcher-field{
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 500px
    }
    .searcher-result{
    font-size: smaller;
    padding: 2px 0px 2px 0px;
    cursor: pointer;
    }
.ajusteOP{
    height: 35%;
    width: 100%;
    position: relative; 
    overflow-y: auto; /* Permite solo el scroll vertical */
    overflow-x: hidden; /* Oculta el scroll horizontal */
}
.formasPagosImg{
width: 100%;
height: 40%;
margin-top:50%;
border-radius:30px;
cursor: pointer;
}
.colorTituloCategoria{
    color: green;
    font-weight: bold;
}
.star-yellow {
  color: yellow; /* Cambia el color del botón a amarillo */
}
.scrollFavoritos::-webkit-scrollbar {
    -webkit-appearance: none;
}

.scrollFavoritos::-webkit-scrollbar:vertical {
    width:10px;
}

.scrollFavoritos::-webkit-scrollbar-button:increment,.contenedor::-webkit-scrollbar-button {
    display: none;
} 

.scrollFavoritos::-webkit-scrollbar:horizontal {
    height: 10px;
}

.scrollFavoritos::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.scrollFavoritos::-webkit-scrollbar-track {
    border-radius: 10px;  
}
.scrollFavoritos {
    height: 156px; /* Establece un alto fijo para el contenedor */
    overflow-y: auto; /* Permite scroll vertical */
    overflow-x: hidden; /* Oculta el scroll horizontal */
    padding-right: 5px; /* Es*/
}
.listaproducto{
    display: inline-block;
}
</style>